import type { StatCardProps } from "@/components/molecules/StatCard";
import { Moneys } from "iconsax-react";

export const FINANCE_STATS: StatCardProps[] = [
  {
    title: "Total Revenue (This Month)",
    value: "$12,745",
    icon: <Moneys variant="Bold" color="#484848" className="w-6 h-6" />,
    trend: { value: "+3.2%", type: "increase" },
  },
  {
    title: "Total Transactions",
    value: "$30,921",
    icon: <Moneys variant="Bold" color="#484848" className="w-6 h-6" />,
    trend: { value: "+3.2%", type: "decrease" },
  },
  {
    title: "Successful Payments",
    value: "$10,000",
    icon: <Moneys variant="Bold" color="#484848" className="w-6 h-6" />,
  },
  {
    title: "Refunds Issued",
    value: "$1,745",
    icon: <Moneys variant="Bold" color="#484848" className="w-6 h-6" />,
  },
  {
    title: "Failed Payments",
    value: "200",
    icon: <Moneys variant="Bold" color="#484848" className="w-6 h-6" />,
  },
  {
    title: "Pending Payouts",
    value: "$3,190",
    icon: <Moneys variant="Bold" color="#484848" className="w-6 h-6" />,
  },
];

export interface Transaction {
  id: string;
  transactionID: string;
  userName: string;
  type: string;
  amount: string;
  paymentMethod: string;
  date: string;
  status: "Success" | "Failed";
}

export const MOCK_TRANSACTIONS: Transaction[] = [
  {
    id: "1",
    transactionID: "TXN-00123",
    userName: "@sarah_p",
    type: "Group Join (Yoga Meetup)",
    amount: "$2.00",
    paymentMethod: "Credit Card",
    date: "12 Mar 2025",
    status: "Success",
  },
  {
    id: "1",
    transactionID: "TXN-00123",
    userName: "@sarah_p",
    type: "Group Join (Yoga Meetup)",
    amount: "$2.00",
    paymentMethod: "Credit Card",
    date: "12 Mar 2025",
    status: "Success",
  },
  {
    id: "1",
    transactionID: "TXN-00123",
    userName: "@sarah_p",
    type: "Group Join (Yoga Meetup)",
    amount: "$2.00",
    paymentMethod: "Credit Card",
    date: "12 Mar 2025",
    status: "Success",
  },
  {
    id: "1",
    transactionID: "TXN-00123",
    userName: "@sarah_p",
    type: "Group Join (Yoga Meetup)",
    amount: "$2.00",
    paymentMethod: "Credit Card",
    date: "12 Mar 2025",
    status: "Success",
  },
];

export interface Payout {
  id: number;
  name: string;
  amount: number;
  method: string;
  status: "Completed" | "Pending";
}

export const recentPayouts: Payout[] = [
  {
    id: 1,
    name: "John Doe",
    amount: 1000,
    method: "Bank Transfer",
    status: "Completed",
  },
  {
    id: 2,
    name: "John Doe",
    amount: 1000,
    method: "Bank Transfer",
    status: "Completed",
  },
];

export const TRANSACTION_TABLE_HEADERS = [
  "Transaction ID",
  "User Name",
  "Type",
  "Amount",
  "Payment Method",
  "Date",
  "Status",
];
